import PropTypes from "prop-types";

import Dropdown from "../../shared/v2/Dropdown/Dropdown";

const RoutingNumbersDropdown = ({ selectedNumberId, numbers, onChange, isLoading }) => {
  const phoneOptions = numbers.map((n) => ({
    value: n.detailId,
    label: `${n.routingNumber} (${n.category})`,
    meta: {
      link: n.updateRoutingPath,
    },
  }));

  const phone = phoneOptions.find((s) => s.value === selectedNumberId);

  return (
    <Dropdown
      isDisabled={isLoading}
      className="tw-whitespace-nowrap tw-w-[210px]"
      value={phone}
      options={phoneOptions}
      onChange={onChange}
    />
  );
};

RoutingNumbersDropdown.propTypes = {
  selectedNumberId: PropTypes.string,
  isLoading: PropTypes.bool,
  numbers: PropTypes.arrayOf(
    PropTypes.shape({
      detailId: PropTypes.string,
      routingNumber: PropTypes.string,
      category: PropTypes.string,
      updateRoutingNumber: PropTypes.string,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};

RoutingNumbersDropdown.defaultProps = {
  selectedNumberId: null,
  isLoading: false,
};

export default RoutingNumbersDropdown;
